(() => {
  const SECTION_SELECTOR = "[data-subscription-root]";

  const initHero = (root) => {
    const media = root.querySelector(".subscription-hero__media");
    if (!media) return;

    const youtubeSrc = media.getAttribute("data-youtube-src");
    if (!youtubeSrc) return;

    const loadIframe = () => {
      if (media.querySelector("iframe")) return;

      const iframe = document.createElement("iframe");
      iframe.className = "subscription-hero__iframe";
      iframe.width = "560";
      iframe.height = "315";

      const autoplaySrc = youtubeSrc.includes("?")
  ? youtubeSrc + "&autoplay=1&mute=1&playsinline=1&controls=0&modestbranding=1&rel=0&iv_load_policy=3"
  : youtubeSrc + "?autoplay=1&mute=1&playsinline=1&controls=0&modestbranding=1&rel=0&iv_load_policy=3";

      iframe.src = autoplaySrc;
      iframe.title = "YouTube video player";
      iframe.frameBorder = "0";
      iframe.allow =
        "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share";
      iframe.referrerPolicy = "strict-origin-when-cross-origin";
      iframe.allowFullscreen = true;
      iframe.setAttribute("allow", iframe.allow);

      iframe.addEventListener(
        "load",
        () => {
          media.classList.add("subscription-hero__media--loaded");
        },
        { once: true }
      );

      media.appendChild(iframe);
    };

    const scheduleLoad = () => {
      if ("requestIdleCallback" in window) {
        window.requestIdleCallback(loadIframe, { timeout: 1500 });
      } else {
        setTimeout(loadIframe, 0);
      }
    };

    if (document.readyState === "complete") scheduleLoad();
    else window.addEventListener("load", scheduleLoad, { once: true });
  };

  const initBenefitsTouch = (root) => {
    const isTouch =
      window.matchMedia &&
      window.matchMedia("(hover: none) and (pointer: coarse)").matches;
    if (!isTouch) return;

    const list = root.querySelector(".subscription-benefits__list");
    if (!list) return;

    const cards = Array.from(list.querySelectorAll(".subscription-benefit"));
    if (!cards.length) return;

    const deactivateAll = () => {
      cards.forEach((card) => card.classList.remove("subscription-benefit--active"));
    };

    root.addEventListener("click", (event) => {
      if (!event.target) return;
      if (event.target.closest("a")) return;

      const clickedCard = event.target.closest(".subscription-benefits__list .subscription-benefit");
      if (!clickedCard) {
        deactivateAll();
        return;
      }

      const wasActive = clickedCard.classList.contains("subscription-benefit--active");
      deactivateAll();
      if (!wasActive) clickedCard.classList.add("subscription-benefit--active");
    });
  };

  const initSection = (root) => {
    if (!root || root.dataset.subscriptionInitialized === "true") return;
    root.dataset.subscriptionInitialized = "true";

    initHero(root);
    initBenefitsTouch(root);
  };

  const initAll = () => {
    document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", (event) => {
    if (!event || !event.target) return;
    const root = event.target.querySelector(SECTION_SELECTOR);
    if (root) initSection(root);
  });
})();

